"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;

var _react = _interopRequireDefault(require("react"));

var _Spinner = require("./Spinner.style");

var Spinner = function Spinner() {
  return /*#__PURE__*/_react.default.createElement(_Spinner.SpinnerWrapper, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "loading"
  }));
};

exports.Spinner = Spinner;